import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../lib/metaPixel';
export function StickyCTA() {
  return <div className="fixed bottom-0 left-0 right-0 z-50 p-4 pointer-events-none flex justify-center" data-id="element-142">
      <motion.a href="https://www.legadosalud.com/cart/42654220582997:1" onClick={trackAddToCart} initial={{
      y: 100
    }} animate={{
      y: 0
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 20,
      delay: 1
    }} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className="pointer-events-auto w-full md:max-w-[400px] bg-gold text-white text-center py-4 px-6 rounded-2xl shadow-[0_-10px_40px_rgba(201,168,76,0.3)] border border-white/20 flex flex-col items-center justify-center" data-id="element-143">
        <span className="font-bold text-lg md:text-xl tracking-wide" data-id="element-144">
          Descárgalo AHORA — $9.99 USD
        </span>
        <span className="text-sm font-medium opacity-90 mt-0.5" data-id="element-145">
          <span className="line-through mr-2" data-id="element-146">$37 USD</span> → $9.99 USD
        </span>
      </motion.a>
    </div>;
}